// Libs
import { SWRConfig, SWRConfiguration } from 'swr';
import { AxiosError } from 'axios';

const CLIENT_ERROR_MIN_STATUS = 400;
const SERVER_ERROR_MIN_STATUS = 500;

const isClientError = (error: AxiosError): boolean => {
  const status = error.response && error.response.status;
  const isClientErrorStatus = status >= CLIENT_ERROR_MIN_STATUS && status < SERVER_ERROR_MIN_STATUS;

  return isClientErrorStatus;
};

/**
 * Retry a failed request with the default swr backoff, except on a 4xx:
 * the same request would be refused again, and retrying a 401 after the token
 * expired only repeats the whole batch of calls of the page against the api
 */
export const retryUnlessClientError: SWRConfiguration['onErrorRetry'] = (
  error,
  key,
  config,
  revalidate,
  revalidateOptions
) => {
  if (isClientError(error as AxiosError)) return;

  SWRConfig.default.onErrorRetry(error, key, config, revalidate, revalidateOptions);
};
